import React from "react";
import { TrendingUp, FileCheck2, Scale, Coffee } from "lucide-react";
import { FEATURE_CARDS } from "../mock/mock";
import { useContent } from "../context/ContentContext";

const iconMap = { TrendingUp, FileCheck2, Scale, Coffee };

export default function FeatureIcons() {
  const { featureCards = FEATURE_CARDS } = useContent();
  return (
    <section className="relative bg-[#0a0a0a] py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-20">
          <div className="flex items-center gap-3 mb-5">
            <span className="divider-line" />
            <span className="text-[11px] tracking-[0.4em] text-[#B87333]">AR DANIŞMANLIK</span>
          </div>
          <h2 className="font-serif-display text-[#f5ede1] text-4xl md:text-5xl lg:text-6xl leading-tight font-light">
            İşletmenizin büyümesini desteklemek için buradayız.{" "}
            <span className="text-[#B87333] italic">Geleceğinizi</span> birlikte şekillendirelim.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#B87333]/15">
          {featureCards.map((card, idx) => {
            const Icon = iconMap[card.icon] || TrendingUp;
            return (
              <div
                key={idx}
                className="group bg-[#0a0a0a] p-10 lg:p-12 hover:bg-[#141010] transition-colors duration-500"
              >
                <div className="w-14 h-14 border border-[#B87333]/40 flex items-center justify-center mb-8 group-hover:border-[#B87333] group-hover:bg-[#B87333]/10 transition-all duration-500">
                  <Icon className="w-6 h-6 text-[#B87333]" strokeWidth={1.25} />
                </div>
                <h3 className="font-serif-display text-[#f5ede1] text-xl lg:text-2xl mb-4 leading-snug">
                  {card.title}
                </h3>
                <p className="text-[#a89a85] text-sm leading-relaxed">{card.text}</p>
                <div className="mt-8 h-px w-0 group-hover:w-16 bg-[#B87333] transition-all duration-700" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
